/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as Setup2faRouteImport } from './routes/setup-2fa'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppAuditRouteImport } from './routes/_app/audit'
import { Route as AppEntriesRouteImport } from './routes/_app/entries'
import { Route as AppImportsRouteImport } from './routes/_app/imports'
import { Route as AppStatsRouteImport } from './routes/_app/stats'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AppCasesIndexRouteImport } from './routes/_app/cases/index'
import { Route as AppCasesCaseIdRouteImport } from './routes/_app/cases/$caseId'
import { Route as AppCasesNewRouteImport } from './routes/_app/cases/new'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients/index'
import { Route as AppClientsClientIdRouteImport } from './routes/_app/clients/$clientId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const Setup2faRoute = Setup2faRouteImport.update({
  id: '/setup-2fa',
  path: '/setup-2fa',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppEntriesRoute = AppEntriesRouteImport.update({
  id: '/entries',
  path: '/entries',
  getParentRoute: () => AppRoute,
} as any)
const AppImportsRoute = AppImportsRouteImport.update({
  id: '/imports',
  path: '/imports',
  getParentRoute: () => AppRoute,
} as any)
const AppStatsRoute = AppStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppCasesIndexRoute = AppCasesIndexRouteImport.update({
  id: '/cases/',
  path: '/cases/',
  getParentRoute: () => AppRoute,
} as any)
const AppCasesCaseIdRoute = AppCasesCaseIdRouteImport.update({
  id: '/cases/$caseId',
  path: '/cases/$caseId',
  getParentRoute: () => AppRoute,
} as any)
const AppCasesNewRoute = AppCasesNewRouteImport.update({
  id: '/cases/new',
  path: '/cases/new',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsClientIdRoute = AppClientsClientIdRouteImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup-2fa': typeof Setup2faRoute
  '/verify': typeof VerifyRoute
  '/account': typeof AppAccountRoute
  '/audit': typeof AppAuditRoute
  '/entries': typeof AppEntriesRoute
  '/imports': typeof AppImportsRoute
  '/stats': typeof AppStatsRoute
  '/users': typeof AppUsersRoute
  '/cases/$caseId': typeof AppCasesCaseIdRoute
  '/cases/new': typeof AppCasesNewRoute
  '/clients/$clientId': typeof AppClientsClientIdRoute
  '/cases/': typeof AppCasesIndexRoute
  '/clients/': typeof AppClientsIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup-2fa': typeof Setup2faRoute
  '/verify': typeof VerifyRoute
  '/account': typeof AppAccountRoute
  '/audit': typeof AppAuditRoute
  '/entries': typeof AppEntriesRoute
  '/imports': typeof AppImportsRoute
  '/stats': typeof AppStatsRoute
  '/users': typeof AppUsersRoute
  '/': typeof AppIndexRoute
  '/cases/$caseId': typeof AppCasesCaseIdRoute
  '/cases/new': typeof AppCasesNewRoute
  '/clients/$clientId': typeof AppClientsClientIdRoute
  '/cases': typeof AppCasesIndexRoute
  '/clients': typeof AppClientsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup-2fa': typeof Setup2faRoute
  '/verify': typeof VerifyRoute
  '/_app/account': typeof AppAccountRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/entries': typeof AppEntriesRoute
  '/_app/imports': typeof AppImportsRoute
  '/_app/stats': typeof AppStatsRoute
  '/_app/users': typeof AppUsersRoute
  '/_app/': typeof AppIndexRoute
  '/_app/cases/$caseId': typeof AppCasesCaseIdRoute
  '/_app/cases/new': typeof AppCasesNewRoute
  '/_app/clients/$clientId': typeof AppClientsClientIdRoute
  '/_app/cases/': typeof AppCasesIndexRoute
  '/_app/clients/': typeof AppClientsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/setup-2fa'
    | '/verify'
    | '/account'
    | '/audit'
    | '/entries'
    | '/imports'
    | '/stats'
    | '/users'
    | '/cases/$caseId'
    | '/cases/new'
    | '/clients/$clientId'
    | '/cases/'
    | '/clients/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/setup-2fa'
    | '/verify'
    | '/account'
    | '/audit'
    | '/entries'
    | '/imports'
    | '/stats'
    | '/users'
    | '/'
    | '/cases/$caseId'
    | '/cases/new'
    | '/clients/$clientId'
    | '/cases'
    | '/clients'
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/setup-2fa'
    | '/verify'
    | '/_app/account'
    | '/_app/audit'
    | '/_app/entries'
    | '/_app/imports'
    | '/_app/stats'
    | '/_app/users'
    | '/_app/'
    | '/_app/cases/$caseId'
    | '/_app/cases/new'
    | '/_app/clients/$clientId'
    | '/_app/cases/'
    | '/_app/clients/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  Setup2faRoute: typeof Setup2faRoute
  VerifyRoute: typeof VerifyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup-2fa': {
      id: '/setup-2fa'
      path: '/setup-2fa'
      fullPath: '/setup-2fa'
      preLoaderRoute: typeof Setup2faRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/entries': {
      id: '/_app/entries'
      path: '/entries'
      fullPath: '/entries'
      preLoaderRoute: typeof AppEntriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/imports': {
      id: '/_app/imports'
      path: '/imports'
      fullPath: '/imports'
      preLoaderRoute: typeof AppImportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stats': {
      id: '/_app/stats'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof AppStatsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cases/': {
      id: '/_app/cases/'
      path: '/cases'
      fullPath: '/cases/'
      preLoaderRoute: typeof AppCasesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cases/$caseId': {
      id: '/_app/cases/$caseId'
      path: '/cases/$caseId'
      fullPath: '/cases/$caseId'
      preLoaderRoute: typeof AppCasesCaseIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cases/new': {
      id: '/_app/cases/new'
      path: '/cases/new'
      fullPath: '/cases/new'
      preLoaderRoute: typeof AppCasesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/': {
      id: '/_app/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/$clientId': {
      id: '/_app/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AppClientsClientIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppAuditRoute: typeof AppAuditRoute
  AppEntriesRoute: typeof AppEntriesRoute
  AppImportsRoute: typeof AppImportsRoute
  AppStatsRoute: typeof AppStatsRoute
  AppUsersRoute: typeof AppUsersRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCasesCaseIdRoute: typeof AppCasesCaseIdRoute
  AppCasesNewRoute: typeof AppCasesNewRoute
  AppClientsClientIdRoute: typeof AppClientsClientIdRoute
  AppCasesIndexRoute: typeof AppCasesIndexRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppAuditRoute: AppAuditRoute,
  AppEntriesRoute: AppEntriesRoute,
  AppImportsRoute: AppImportsRoute,
  AppStatsRoute: AppStatsRoute,
  AppUsersRoute: AppUsersRoute,
  AppIndexRoute: AppIndexRoute,
  AppCasesCaseIdRoute: AppCasesCaseIdRoute,
  AppCasesNewRoute: AppCasesNewRoute,
  AppClientsClientIdRoute: AppClientsClientIdRoute,
  AppCasesIndexRoute: AppCasesIndexRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  Setup2faRoute: Setup2faRoute,
  VerifyRoute: VerifyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
